import "./tag.css";

const Tag = ({ value }: { value: string }) => (
  <div className={"containerTag"}>{value}</div>
);

export { Tag };
